import englishMessages from "ra-language-english";
import {default as english} from "./en_EN";
import polyglotI18nProvider from "ra-i18n-polyglot";

export const i18nProvider = polyglotI18nProvider(
  (locale) => (locale === "en" ? english : englishMessages),
  "en"
);
